module.exports = __webpack_public_path__ + "img/8W.4e4598ed.png";